import { AccountStatus } from 'dashboard/models/account-status';
import { AccountType, AccountTypesFilterOption } from 'dashboard/models/account-type';
import Action from 'lib/interfaces/Action';

export type AccountTypesActions =
  | Action<AccountTypesActionType.SetAccountTypes, SetAccountTypesPayload>
  | Action<AccountTypesActionType.SetFilterOptions, SetFilterOptionsPayload>;

export enum AccountTypesActionType {
  SetAccountTypes = 'account-types/SET_ACCOUNT_TYPES',
  SetFilterOptions = 'account-types/SET_FILTER_OPTIONS',
}

interface SetAccountTypesPayload {
  accountTypes: AccountType[];
  accountStatuses: AccountStatus[];
}

export function setAccountTypes(
  accountTypes: AccountType[],
  accountStatuses: AccountStatus[],
): Action<AccountTypesActionType.SetAccountTypes, SetAccountTypesPayload> {
  return {
    payload: {
      accountTypes,
      accountStatuses,
    },
    type: AccountTypesActionType.SetAccountTypes,
  };
}

interface SetFilterOptionsPayload {
  filterOptions: AccountTypesFilterOption[];
}

export function setAccountTypesFilterOptions(
  filterOptions: SetFilterOptionsPayload['filterOptions'],
): Action<AccountTypesActionType.SetFilterOptions, SetFilterOptionsPayload> {
  return {
    payload: {
      filterOptions,
    },
    type: AccountTypesActionType.SetFilterOptions,
  };
}
